module.exports = __webpack_public_path__ + "media/sanctuary-master-480.9a8094a6.mp4";